module.exports = __webpack_public_path__ + "d5c58933285eb4c45cc253e9a6ebfa94.pdf";